import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "./commonLanguageHeader";
import { ServicesUrlEndpoints } from "./servicesEndpointConstant";

export interface VehicleListParams {
  clientId: string | number;
  page?: number;
  size?: number;
  sort?: "ASC" | "DESC";
  [key: string]: unknown;
}

export interface VehicleListResponse {
  vehicleInfos?: unknown[];
  vehicles?: unknown[];
  items?: unknown[];
  data?: unknown[];
  content?: unknown[];
  currentPage?: number;
  totalPages?: number;
  totalItems?: number;
  total?: number;
  totalElements?: number;
  size?: number;
  page?: number;
  [key: string]: unknown;
}

export interface MoveVehiclesPayload {
  currentCustomerId: number;
  newCustomerId: number;
  vehicleIds: number[];
}

export const getVehicleList = (
  params: VehicleListParams,
  language?: string,
) => {
  return ApiService.get<{ response: VehicleListResponse | unknown[] }>(
    ServicesUrlEndpoints.VEHICLE.LIST,
    {
      params,
      ...getLanguageHeaders(language),
    },
  );
};

export const moveVehiclesToCustomer = (
  payload: MoveVehiclesPayload,
  language?: string,
) =>
  ApiService.post(ServicesUrlEndpoints.VEHICLE.MOVE_CUSTOMER, payload, {
    ...getLanguageHeaders(language),
  });
